import { getApiUrl } from '../config/api';
import { IRAN_TIMEZONE } from './iranTime';

let clockOffsetMs = 0;
let clockSource = 'device';

const parseServerInstant = (input) => {
  if (input == null || input === '') return null;
  if (typeof input === 'number') {
    const ms = input < 1e12 ? input * 1000 : input;
    return Number.isFinite(ms) ? ms : null;
  }
  const ms = new Date(input).getTime();
  return Number.isFinite(ms) ? ms : null;
};

/**
 * همگام‌سازی با زمان مرجع (سرور یا منبع رسمی).
 * منبع worldtime بر منبع server اولویت دارد.
 */
export const applyOfficialClockOffset = (serverInstant, { source = 'server' } = {}) => {
  const serverMs = parseServerInstant(serverInstant);
  if (serverMs == null) return false;

  if (source === 'worldtime' || clockSource !== 'worldtime') {
    clockOffsetMs = serverMs - Date.now();
    clockSource = source;
    return true;
  }
  return false;
};

export const isIranOfficialClockSynced = () => clockSource !== 'device';

export const getIranOfficialNow = () => new Date(Date.now() + clockOffsetMs);

export const getDeviceClockSkewSeconds = () => Math.round(clockOffsetMs / 1000);

export const resetOfficialClock = () => {
  clockOffsetMs = 0;
  clockSource = 'device';
};

export const syncIranOfficialClockFromWorldTime = async () => {
  try {
    const res = await fetch('https://worldtimeapi.org/api/timezone/Asia/Tehran', {
      signal: AbortSignal.timeout(6000),
    });
    if (!res.ok) return false;
    const data = await res.json();
    if (data.unixtime != null) {
      return applyOfficialClockOffset(data.unixtime, { source: 'worldtime' });
    }
    if (data.datetime) {
      return applyOfficialClockOffset(data.datetime, { source: 'worldtime' });
    }
  } catch (error) {
    console.warn('WorldTime API unavailable:', error);
  }
  return false;
};

export const syncIranOfficialClockFromBackend = async () => {
  try {
    const token = localStorage.getItem('authToken');
    const res = await fetch(getApiUrl('attendances/today'), {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      signal: AbortSignal.timeout(8000),
    });
    const dateHeader = res.headers.get('Date');
    if (dateHeader && applyOfficialClockOffset(dateHeader, { source: 'server' })) {
      return true;
    }
    if (res.ok) {
      const body = await res.json();
      const root = body?.data && typeof body.data === 'object' ? body.data : body;
      const serverTime = root?.current_time || root?.server_time || root?.now;
      if (serverTime) {
        return applyOfficialClockOffset(serverTime, { source: 'server' });
      }
    }
  } catch (error) {
    console.warn('Backend clock sync failed:', error);
  }
  return false;
};

export const syncIranOfficialClock = async () => {
  resetOfficialClock();
  const worldOk = await syncIranOfficialClockFromWorldTime();
  if (worldOk) return true;
  return syncIranOfficialClockFromBackend();
};

export const formatDeviceTimeInTehran = (date = new Date(), options = {}) =>
  date.toLocaleTimeString('fa-IR', {
    timeZone: IRAN_TIMEZONE,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    ...options,
  });

export const formatSkewLabel = (skewSeconds) => {
  const abs = Math.abs(skewSeconds);
  if (abs < 45) return null;
  if (abs < 90) return `${Math.round(abs / 60) || 1} دقیقه`;
  const minutes = Math.round(abs / 60);
  if (minutes < 120) return `${minutes} دقیقه`;
  const hours = Math.floor(minutes / 60);
  const rem = minutes % 60;
  return rem > 0 ? `${hours} ساعت و ${rem} دقیقه` : `${hours} ساعت`;
};
